import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Container,
  Row,
  Col,
  Card,
  CardTitle,
  CardBody,
  Button,
  Spinner,
} from "reactstrap";
import { Link } from "react-router-dom";
import { get } from "helpers/api_helper";
import imageDashboard from '../../assets/images/dashboard.svg';
import SweetAlert from "react-bootstrap-sweetalert";


//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";
import LoadingSpinner from "components/Common/LoadingSpinner";

const Dashboard = props => {
  const [dataSiswa, setDataSiswa] = useState({
    not_requested_yet: 0, 
    requested_normal: 0, 
    requested_early: 0, 
    pickuped_normal: 0, 
    pickuped_early: 0, 
    expired_normal: 0,
    expired_early: 0,
    total_requested: 0,
    total_pickuped: 0,
    total_expired: 0,
    total_precense: 0
  });
  const [jumlahSiswa,setJumlahSiswa] = useState(0);
  const [error_alert, seterror_alert] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [loadSync, setLoadSync] = useState(false);
  const [success_alert, setsuccess_alert] = useState(false);
  const [text_success_alert, settext_success_alert] = useState(false)
  const [error_sync_alert, seterror_sync_alert] = useState(false);

  const getData = async ()=> {
    setLoading(true);
    try {
      let responsePickup = await get("/student/all/pickup");
      const data = responsePickup.data;
      const pickup = data.filter(x => x.pickup !== null);
      const requestedNormal = pickup.filter(x => x.pickup.status === 'accepted' && x.pickup.is_early === false).length;
      const requestedEarly = pickup.filter(x => x.pickup.status === 'accepted' && x.pickup.is_early === true).length;
      const pickupedNormal = pickup.filter(x => x.pickup.status === 'done' && x.pickup.is_early === false).length;
      const pickupedEarly = pickup.filter(x => x.pickup.status === 'done' && x.pickup.is_early === true).length;
      const expiredNormal = pickup.filter(x => x.pickup.status === 'canceled' && x.pickup.is_early === false).length;
      const expiredEarly = pickup.filter(x => x.pickup.status === 'canceled' && x.pickup.is_early === true).length;
      const totalRequested = requestedNormal + requestedEarly
      const totalPickuped = pickupedNormal + pickupedEarly
      const totalExpired = expiredNormal + expiredEarly

  
      const notRequestedYet = data.filter(x => x.pickup === null).length;
      setDataSiswa({...dataSiswa, 
        not_requested_yet: notRequestedYet, 
        requested_normal: requestedNormal, 
        requested_early: requestedEarly, 
        pickuped_normal: pickupedNormal, 
        pickuped_early: pickupedEarly, 
        expired_normal: expiredNormal,
        expired_early: expiredEarly,
        total_requested: totalRequested,
        total_pickuped: totalPickuped,
        total_expired: totalExpired,
        total_precense: data.length
      });
      setJumlahSiswa(data.length)
      setLoading(false)
    } catch (error) {
      console.log(error)
      seterror_alert(true);
    }
  }

  useEffect (() => {
    getData();
  }, []);

  useEffect(() => {
    const fetchData = setInterval(getData,10000)
    return () => clearInterval(fetchData)
  },[])

  const syncDataPresence = async () => {
    setLoadSync(true)
    try {
      const syncNormal = await get('/tzuchidb/mergeabsen');
      const syncDaycare = await get('/tzuchidb/mergeabsen?tb=ABSEN_DAYCARE');
      if (syncNormal && syncDaycare) {
        setLoadSync(false)
        setsuccess_alert(true)
        settext_success_alert('sync presence data')
      }
    } catch (error) {
      setLoadSync(false)
      seterror_sync_alert(true)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Tzu Chi</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Pickup")}
            breadcrumbItem={props.t("Dashboard")}
          />

          <Row>
            <Col className="col-12">
              <Card className="bg-primary bg-opacity-25 px-2 py-welcome" style={{position: 'relative'}}>
                <CardBody>
                  <div>
                    <CardTitle className="h4 text-primary">Welcome!</CardTitle>
                    <p className="text-primary mb-0">Tzu Chi School Pickup System Management Dashboard</p>
                    <div className="mt-3">
                      {loadSync ? (
                        <Button color="primary" className="btn-sm" disabled>
                          Sync Presence Data
                          <Spinner
                            animation="border"
                            className="ms-2"
                            style={{ width: "1rem", height: "1rem" }}
                          />
                        </Button>
                      ) : (
                        <Button
                          color="primary"
                          onClick={syncDataPresence}
                          className="btn-sm"
                        >
                          Sync Presence Data
                        </Button>
                      )}
                    </div>
                  </div>
                  <div style={{position: 'absolute', bottom: 0, right: 50}}>
                    <img src={imageDashboard} className="w-welcome" />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col className="col-12">
              <Card style={{minHeight: 270}}>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <CardTitle className="h4 mb-0">Pickup Status</CardTitle>

                      {isLoading ? (
                        <p className="card-title-desc mb-0">sync data...</p>
                      ) : (
                        <p className="card-title-desc mb-0">
                          Total students present: {jumlahSiswa}
                        </p>
                      )}
                    </div>

                    {isLoading && (
                      <div className="d-flex align-items-center">
                        <LoadingSpinner />
                      </div>
                    )}
                  </div>
                  
                  <Row>
                    <Col md="3">
                      <Link to={`/pickup/penjemputan?status=not-requested`}>
                        <div className="bg-secondary bg-opacity-50 rounded-circle m-auto text-center" style={{width: 150, height: 150}}>
                          <div className="d-flex flex-row justify-content-center align-item-center text-secondary fw-bold" style={{lineHeight: 3, fontSize: 50}}>
                            {dataSiswa.not_requested_yet}
                          </div>
                        </div>
                        <div className="text-center mt-2">
                          <span className="fw-semibold">
                            {/* Total Precense: {dataSiswa.total_precense} */}
                          </span>
                        </div>
                      </Link>
                      <div className="text-center my-3">Not Requested Yet</div>
                    </Col>

                    <Col md="3">
                      <Link to={`/pickup/penjemputan?status=waiting-to-be-released`}>
                        <div className="bg-info bg-opacity-50 rounded-circle m-auto text-center" style={{width: 150, height: 150}}>
                          <div className="d-flex flex-row justify-content-center align-item-center text-primary fw-bold" style={{lineHeight: 3, fontSize: 50}}>
                            {dataSiswa.total_requested}
                          </div>
                        </div>
                        <div className="text-center mt-2">
                          <span className="fw-semibold">
                            Normal: {dataSiswa.requested_normal}
                          </span>
                          {' | '}
                          <span
                            className="fw-semibold"
                            style={{ color: '#fd7e14' }}
                          >
                            Early: {dataSiswa.requested_early}
                          </span>
                        </div>
                      </Link>
                      <div className="text-center my-3">Waiting To Be Released</div>
                    </Col>

                    <Col md="3">
                      <Link to={`/pickup/penjemputan?status=finished`}>
                        <div className="bg-success bg-opacity-50 rounded-circle m-auto text-center" style={{width: 150, height: 150}}>
                          <div className="d-flex flex-row justify-content-center align-item-center text-success fw-bold" style={{lineHeight: 3, fontSize: 50}}>
                            {dataSiswa.total_pickuped}
                          </div>
                        </div>
                        <div className="text-center mt-2">
                          <span className="fw-semibold">
                            Normal: {dataSiswa.pickuped_normal}
                          </span>
                          {' | '}
                          <span
                            className="fw-semibold"
                            style={{ color: '#fd7e14' }}
                          >
                            Early: {dataSiswa.pickuped_early}
                          </span>
                        </div>
                      </Link>
                      <div className="text-center my-3">Finished Pickup</div>
                    </Col>
                    <Col md="3">
                    <Link to={`/pickup/penjemputan?status=qr-code-expired`}>
                      <div className="bg-danger bg-opacity-50 rounded-circle m-auto text-center" style={{width: 150, height: 150}}>
                        <div className="d-flex flex-row justify-content-center align-item-center text-danger fw-bold" style={{lineHeight: 3, fontSize: 50}}>
                          {dataSiswa.total_expired}
                        </div>
                      </div>
                      <div className="text-center mt-2">
                          <span className="fw-semibold">
                            Normal: {dataSiswa.expired_normal}
                          </span>
                          {' | '}
                          <span
                            className="fw-semibold"
                            style={{ color: '#fd7e14' }}
                          >
                            Early: {dataSiswa.expired_early}
                          </span>
                        </div>
                    </Link>
                    <div className="text-center my-3">QR Code Expired</div>
                  </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>

            {/* <Col className="col-3">
              <Card style={{minHeight: 270}}>
                <CardBody>
                  <CardTitle className="h4">QR Code Expired</CardTitle>
                  <p className="card-title-desc"></p>
                  <Row>
                    <Col md="12">
                      <Link to={`/pickup/penjemputan?status=canceled`}>
                        <div className="bg-danger bg-opacity-50 rounded-circle m-auto text-center" style={{width: 150, height: 150}}>
                          <div className="d-flex flex-row justify-content-center align-item-center text-danger fw-bold" style={{lineHeight: 3, fontSize: 50}}>
                            {dataSiswa.expired}
                          </div>
                        </div>
                      </Link>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col> */}
          </Row>

        </Container>
      </div>

      { error_alert ?
          <SweetAlert
              title="Oppss!"
              confirmBtnText="Yes"
              error
              confirmBtnBsStyle="primary"
              onConfirm={() => {
                  seterror_alert(false)
              }}
          >
              Cannot retrieve data from server
          </SweetAlert>
      : null }

      {success_alert && (
        <SweetAlert
          title="Success!"
          confirmBtnText="Yes"
          success
          confirmBtnBsStyle="primary"
          onConfirm={() => {
            setsuccess_alert(false)
          }}
        >
          {text_success_alert}
        </SweetAlert>
      )}
      { error_sync_alert ?
          <SweetAlert
              title="Oppss!"
              confirmBtnText="Yes"
              error
              confirmBtnBsStyle="primary"
              onConfirm={() => {
                  seterror_sync_alert(false)
              }}
          >
              Failed sync presence data
          </SweetAlert>
      : null }
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(Dashboard);
